module.exports = __webpack_public_path__ + "img/memcached.acb93eb5.svg";